import { Component, ElementRef, OnInit, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { fromEvent, merge, Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { SearchData } from '../db/models/search';
import { GenericValidator } from '../directives/generic-validator';
import { SearchService } from '../services/search.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];

  title = 'Search';

  sform: FormGroup;

  searchData = new SearchData();

  displayMessage: { [key: string]: string } = {};
  private validationMessages: { [key: string]: { [key: string]: string } };
  private genericValidator: GenericValidator;

  constructor(private fb: FormBuilder,
        private router: Router,
        private service: SearchService)
        {
          this.validationMessages = {
          name: {
            required: 'Service name is required'
          },
          city:{
            required: 'Please select your city of service'
          }
        }

          this.genericValidator = new GenericValidator(this.validationMessages);
        }

  ngOnInit() {
    this.createDataForm();
  }

  createDataForm(){
    this.sform = this.fb.group({
      name: [null, Validators.required],
      city: [null, Validators.required]
    })
  }

  ngAfterViewInit(): void {
    const controlBlurs: Observable<any>[] = this.formInputElements
      .map((formControl: ElementRef) => fromEvent(formControl.nativeElement, 'blur'));
    merge(this.sform.valueChanges, ...controlBlurs).pipe(
      debounceTime(800)
    ).subscribe(value => {
      this.displayMessage = this.genericValidator.processMessages(this.sform);
    });
  }

  get name(){
    return this.sform.controls.name as FormControl;
  }

  get city() {
    return this.sform.controls.city as FormControl;
  }

  mapEntity(): void {
    this.searchData.category = this.name.value;
    this.searchData.city = this.city.value;
  }

 performSearch(){
    if(this.sform.valid){
      this.mapEntity();
      console.log('New Service', this.searchData);
      this.mapEntity();
      console.log("Search Params", this.searchData);
      this.service.SearchParams = this.searchData
      this.router.navigate(['/search_results']);
    }
  }

}
